(ns practitest.frontend.components2.dashboard.transforms.age
  (:require [practitest.frontend.components2.dashboard.transforms.bar :as b]))

(defn transform [{:chart/keys [x-values-map y-values-map] :as chart}]
  (let [base (b/base-transform chart)]
    (update base :chart/data
            (fn [items]
              (mapv (fn [{:keys [category group] :as item}]
                      (let [age-range (get x-values-map (keyword category))
                            [age-min age-max] age-range
                            y-val     (get y-values-map (keyword group))]
                        (assoc item :url-params
                               {:age-min-param age-min
                                :age-max-param age-max
                                :y-param       y-val})))
                    items)))))
